import { stringifyEntityRef } from '@backstage/catalog-model';
import { ResponseError } from '@backstage/errors';
import { createApiRef } from '@backstage/core-plugin-api';

const codeCoverageApiRef = createApiRef({
  id: "plugin.code-coverage.service"
});
class CodeCoverageRestApi {
  discoveryApi;
  fetchApi;
  constructor(options) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }
  async fetch(path) {
    const url = await this.discoveryApi.getBaseUrl("code-coverage");
    const resp = await this.fetchApi.fetch(`${url}${path}`);
    if (!resp.ok) {
      throw await ResponseError.fromResponse(resp);
    }
    if (resp.headers.get("content-type")?.includes("application/json")) {
      return await resp.json();
    }
    return await resp.text();
  }
  async getCoverageForEntity(entityName) {
    const entity = encodeURIComponent(stringifyEntityRef(entityName));
    return await this.fetch(
      `/report?entity=${entity}`
    );
  }
  async getFileContentFromEntity(entityName, filePath) {
    const entity = encodeURIComponent(stringifyEntityRef(entityName));
    return await this.fetch(
      `/file-content?entity=${entity}&path=${encodeURI(filePath)}`
    );
  }
  async getCoverageHistoryForEntity(entityName, limit) {
    const entity = encodeURIComponent(stringifyEntityRef(entityName));
    const hasValidLimit = limit && limit > 0;
    return await this.fetch(
      `/history?entity=${entity}${hasValidLimit ? `&limit=${encodeURIComponent(String(limit))}` : ""}`
    );
  }
}

export { CodeCoverageRestApi, codeCoverageApiRef };
//# sourceMappingURL=api.esm.js.map
